import { TRESPONSE_LEARNING_CURVE_DETAILS } from '@monorepo/types';
import { TUserPaginationOption } from '@monorepo/ui';

export type TLearningCurveState = {
  learningCurveInfo: TRESPONSE_LEARNING_CURVE_DETAILS | null;
  userPaginationOption: TUserPaginationOption;
};

export type TAddEditRowType = 'ADD' | 'EDIT';

export const TLearningCurveInfoActionType = {
  SetUserPaginationOption: 'SET_LEARNING_CURVE_USER_PAGINATION_OPTION' as const,
  GetLearningCurveInfo: 'GET_LEARNING_CURVE_INFO' as const,
  GetLearningCurveInfoSuccess: 'GET_LEARNING_CURVE_INFO_SUCCESS' as const,
  GetLearningCurveInfoFailure: 'GET_LEARNING_CURVE_INFO_FAILURE' as const,
  AddEditLearningCurve: 'ADD_EDIT_LEARNING_CURVE' as const,
  AddEditLearningCurveSuccess: 'ADD_EDIT_LEARNING_CURVE_SUCCESS' as const,
  AddEditLearningCurveFailure: 'ADD_EDIT_LEARNING_CURVE_FAILURE' as const,
  AddLearningCurveDay: 'ADD_LEARNING_CURVE_DAY' as const,
  AddLearningCurveDaySuccess: 'ADD_LEARNING_CURVE_DAY_SUCCESS' as const,
  AddLearningCurveDayFailure: 'ADD_LEARNING_CURVE_DAY_FAILURE' as const,
  DeleteLearningCurves: 'DELETE_LEARNING_CURVE' as const,
  DeleteLearningCurvesSuccess: 'DELETE_LEARNING_CURVES_SUCCESS' as const,
  DeleteLearningCurvesFailure: 'DELETE_LEARNING_CURVES_FAILURE' as const,
};
